import React from 'react';
import i18n from '@i18n';
import DelayedAppear from '@/common/components/DelayedAppear';

function OverviewLoader({ delay, loaderDelaying }) {
    if (loaderDelaying) {
        return null;
    }
    return (
        <div className="overviewLoader">
            {delay ? (
                <DelayedAppear delay={delay} loader={Void}>
                    <p>{i18n('commons.term.loading')}</p>
                </DelayedAppear>
            ) : (
                <p>{i18n('commons.term.loading')}</p>
            )}
        </div>
    );
}
export default OverviewLoader;

export const Void = () => <p>&nbsp;</p>;
